import { initialState, TCompanyMethods, TCompanyStore } from "./company.state";
import { companyReducer } from "./company.reducer";

// ✅ Reusable store methods
export const createCompanyActions = (
    set: any,
    get: () => TCompanyStore
): Pick<TCompanyStore, TCompanyMethods> => ({
    dispatch: action => set((state: TCompanyStore) => companyReducer(state, action)),

    getSelectedCompanies: () => {
        const allCompanies = get().companies;
        const selectedIds = get().selectedCompanyIds;
        const selectedCompanies = allCompanies.filter(item => selectedIds.includes(item.id));
        return selectedCompanies;
    },

    getCompaniesByDisclosure: disclosureId => {
        return get().filters.filter(item => item.disclosureId === disclosureId);
    },

    getCompanyById: id => {
        return get().companies.find(item => item.id === id);
    },

    isCompanySelected: id => {
        return get().selectedCompanyIds.includes(id);
    },

    reset: () => {
        set(initialState);
    }
});
